import i18next from 'i18next';

export const reviewTagLabel = (tag, t) => (i18next.exists(`themes.${tag}`) ? t(`themes.${tag}`) : tag);
